(function(){
  var root=document.getElementById('oc-pd'); if(!root) return;
  var el=document.getElementById('oc-pj'); if(!el) return;
  var P=JSON.parse(el.textContent), form=root.querySelector('form');
  var idIn=form.querySelector('[name=id]');
  if(!idIn){idIn=document.createElement('input');idIn.type='hidden';idIn.name='id';form.appendChild(idIn)}
  var price=root.querySelector('#oc-price'), add=root.querySelector('#oc-add');
  var cur=currency();
  function currency(){var c=root.getAttribute('data-cur')||'USD';return new Intl.NumberFormat('en-US',{style:'currency',currency:c})}
  function fmt(c){return cur.format(c/100)}
  function sel(){var o=[];root.querySelectorAll('fieldset[data-i]').forEach(function(f){var c=f.querySelector('input:checked');o[+f.getAttribute('data-i')]=c?c.value:null});return o}
  function find(o){return P.variants.find(function(v){return v.options.every(function(x,i){return x===o[i]})})}
  function mark(o){
    root.querySelectorAll('fieldset[data-i]').forEach(function(f){
      var i=+f.getAttribute('data-i');
      f.querySelectorAll('label').forEach(function(l){
        var val=l.querySelector('input').value;
        var ok=P.variants.some(function(v){return v.options[i]===val&&v.available&&v.options.every(function(x,j){return j===i||o[j]==null||x===o[j]})});
        l.classList.toggle('na',!ok);
      });
    });
  }
  function show(v){
    var o=sel(); mark(o);
    root.querySelectorAll('fieldset[data-i]').forEach(function(f){var i=+f.getAttribute('data-i');var b=f.querySelector('[data-val]');if(b)b.textContent=o[i]||''});
    if(!v){idIn.value='';add.disabled=true;add.textContent='Unavailable';return}
    idIn.value=v.id;
    var h=fmt(v.price);
    if(v.compare_at_price&&v.compare_at_price>v.price)h+='<s>'+fmt(v.compare_at_price)+'</s><span class="save">Sale</span>';
    price.innerHTML=h;
    add.disabled=!v.available; add.textContent=v.available?'Add to cart':'Sold out';
    try{history.replaceState(null,'','?variant='+v.id)}catch(e){}
    if(v.featured_media&&v.featured_media.id){var t=root.querySelector('.thumbs [data-id="'+v.featured_media.id+'"]');if(t)t.click()}
  }
  root.querySelectorAll('fieldset[data-i] input').forEach(function(i){i.addEventListener('change',function(){show(find(sel()))})});
  var q=root.querySelector('#oc-q');
  root.querySelector('#oc-minus').onclick=function(){q.value=Math.max(1,(+q.value||1)-1)};
  root.querySelector('#oc-plus').onclick=function(){q.value=(+q.value||1)+1};
  var main=root.querySelector('#oc-main');
  root.querySelectorAll('.thumbs button').forEach(function(b){b.onclick=function(){
    root.querySelectorAll('.thumbs button').forEach(function(x){x.classList.remove('on')});b.classList.add('on');
    var im=main.querySelector('img');if(im){im.src=b.getAttribute('data-full')}
  }});
  if(root.querySelector('fieldset[data-i]')){show(find(sel()))}else{idIn.value=P.variants[0].id}
})();